const salesLabel = [{
  desc: '标签类型分页查询',
  options: {
    url: '/salesLabel/type/queryPage',
    method: 'post'
  }
}, {
  desc: '标签类型新增/修改',
  options: {
    url: '/salesLabel/type/save',
    method: 'post'
  }
}, {
  desc: '标签类型删除',
  options: {
    url: '/salesLabel/type/delete',
    method: 'post'
  }
}, {
  desc: '标签分页查询',
  options: {
    url: '/salesLabel/queryPage',
    method: 'post'
  }
}, {
  desc: '标签新增/修改',
  options: {
    url: '/salesLabel/save',
    method: 'post'
  }
}, {
  desc: '标签删除',
  options: {
    url: '/salesLabel/delete',
    method: 'post'
  }
}, {
  desc: '全部启用标签（打标选择器）',
  options: {
    url: '/salesLabel/queryAll',
    method: 'post'
  }
}, {
  desc: '人员标签详情（已选+可选）',
  options: {
    url: '/salesLabel/sales/query',
    method: 'post'
  }
}, {
  desc: '单人员增量打标（add/remove）',
  options: {
    url: '/salesLabel/sales/save',
    method: 'post'
  }
}, {
  desc: '批量打标',
  options: {
    url: '/salesLabel/sales/batchSave',
    method: 'post'
  }
}, {
  desc: '按人员批量查询标签（列表渲染）',
  options: {
    url: '/salesLabel/sales/labels',
    method: 'post'
  }
}, {
  desc: '按业务端人员ID查询人员信息(姓名/工号)',
  options: {
    url: '/salesLabel/customer/infos',
    method: 'post'
  }
}, {
  desc: '按标签查询业务端人员ID集合(customerId)',
  options: {
    url: '/salesLabel/sales/queryCustomerIdsByLabel',
    method: 'post'
  }
}, {
  desc: '按标签查询人员ID集合（列表筛选）',
  options: {
    url: '/salesLabel/sales/querySalesIdsByLabel',
    method: 'post'
  }
}, {
  desc: '按业务端人员ID集合批量查标签（弹窗标签列）',
  options: {
    url: '/salesLabel/customer/labels',
    method: 'post'
  }
}, {
  desc: '打标/去标/达标审计分页查询',
  options: {
    url: '/salesLabel/track/queryPage',
    method: 'post'
  }
}]
export default salesLabel



// WEBPACK FOOTER //
// ./src/api/salesLabel.js